const initLazyloadVideo = () => {
  const lazyVideoEls = document.querySelectorAll('[data-lazyload-video]');
  if (!lazyVideoEls) return;

  const lazyVideoObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const entryTarget = entry.target;
        const videoSources = entryTarget.querySelectorAll('source');
        videoSources.forEach(videoSource => {
          if (videoSource.dataset.src) {
            videoSource.src = videoSource.dataset.src;
          }
        });
        entryTarget.load();
        lazyVideoObserver.unobserve(entry.target);
      }
    });
  });

  lazyVideoEls.forEach(lazyVideoEl => {
    lazyVideoObserver.observe(lazyVideoEl);
  });
};

export default initLazyloadVideo;
